import NiceModal from '@ebay/nice-modal-react';
import { LinearProgress } from '@mui/material';
import { Provider as RollbarProvider } from '@rollbar/react';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { SnackbarProvider } from 'notistack';
import { NuqsAdapter } from 'nuqs/adapters/react';
import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';

import { store } from 'shared/api';
import rollbar from 'shared/lib/rollbar';

import { AuthProvider } from './providers/AuthProvider';
import { ThemeProvider } from './providers/ThemeProvider';
import { routeTree } from './routeTree';

const router = createRouter({
  routeTree,
  scrollRestoration: true,
  defaultHashScrollIntoView: { behavior: 'smooth' },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

function App() {
  return (
    <RollbarProvider config={rollbar.options}>
      <ReduxProvider store={store}>
        <ThemeProvider>
          <AuthProvider>
            <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
              <NiceModal.Provider>
                <React.Suspense fallback={<LinearProgress />}>
                  <NuqsAdapter>
                    <RouterProvider router={router} defaultPreload="intent" defaultPreloadStaleTime={0} />
                  </NuqsAdapter>
                </React.Suspense>
              </NiceModal.Provider>
            </SnackbarProvider>
          </AuthProvider>
        </ThemeProvider>
      </ReduxProvider>
    </RollbarProvider>
  );
}

export default App;
